import { render, staticRenderFns } from "./PosicionesComponents.vue?vue&type=template&id=25e49435&"
import script from "./PosicionesComponents.vue?vue&type=script&lang=js&"
export * from "./PosicionesComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports